export default function RatingIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="12" fill="#FDEDD7" />
      <path
        d="M18.0328 11.2714C18.8375 9.5762 21.1625 9.57619 21.9672 11.2714L23.3579 14.2012C23.6774 14.8743 24.2951 15.3409 25.0096 15.4489L28.1193 15.9187C29.9187 16.1905 30.6371 18.4895 29.3351 19.8091L27.0849 22.0896C26.5679 22.6136 26.332 23.3685 26.454 24.1084L26.9852 27.3285C27.2926 29.1918 25.4116 30.6126 23.8022 29.7329L21.0208 28.2126C20.3817 27.8633 19.6183 27.8633 18.9792 28.2126L16.1978 29.7329C14.5884 30.6126 12.7074 29.1918 13.0148 27.3286L13.546 24.1084C13.668 23.3685 13.4321 22.6136 12.9151 22.0896L10.6649 19.8091C9.36287 18.4895 10.0813 16.1905 11.8807 15.9187L14.9904 15.4489C15.7049 15.3409 16.3226 14.8743 16.6421 14.2012L18.0328 11.2714Z"
        fill="#EC7323"
      />
    </svg>
  );
}
